export default __webpack_public_path__ + "static/media/mountain-landscape-desk-1x.d9bb9fc7.webp";